<template>
  <div class="callback-container">
    <div class="loading-spinner" v-if="loading">
      <el-icon class="is-loading">
        <Loading />
      </el-icon>
      <p>正在处理飞书授权...</p>
    </div>
    
    <div class="result-message" v-else>
      <div v-if="success" class="success-message">
        <el-icon color="#67C23A">
          <SuccessFilled />
        </el-icon>
        <h3>授权成功！</h3>
        <p>{{ successMessage }}</p>
        <el-button type="primary" @click="goBack">返回工具页面</el-button>
      </div>
      
      <div v-else class="error-message">
        <el-icon color="#F56C6C">
          <CircleCloseFilled />
        </el-icon>
        <h3>授权失败</h3>
        <p>{{ errorMessage }}</p>
        <el-button type="primary" @click="retry">重新授权</el-button>
        <el-button @click="goBack">返回工具页面</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { ElMessage } from 'element-plus'
import { Loading, SuccessFilled, CircleCloseFilled } from '@element-plus/icons-vue'
import axios from 'axios'

export default {
  name: 'CallbackPage',
  components: {
    Loading,
    SuccessFilled,
    CircleCloseFilled
  },
  setup() {
    const router = useRouter()
    const route = useRoute()
    
    const loading = ref(true)
    const success = ref(false)
    const successMessage = ref('')
    const errorMessage = ref('')
    // 处理飞书授权回调
    const handleCallback = async () => {
      try {
        // 从URL参数中获取授权码
        const code = route.query.code
        const state = route.query.state
        console.log('收到飞书授权回调:', { code, state })
        
        if (!code) {
          throw new Error('未收到授权码')
        }
        
        // 向后端发送请求获取user_access_token
        const response = await axios.get('/api/feishu/callback', {
          params: {
            code: code,
            state: state || 'state123'
          },headers: {
            'Content-Type': 'application/json'
          }
        })
        
        if (response.data.code == 0) {
          success.value = true
          successMessage.value = response.data.message || '飞书授权成功，已获取用户访问令牌'
          ElMessage.success('飞书授权成功')
        } else {
          throw new Error(response.data.message || '授权处理失败')
        }
        
      } catch (error) {
        console.error('飞书授权回调处理失败:', error)
        errorMessage.value = error.response?.data?.message || error.message || '授权处理失败，请重试'
        ElMessage.error('飞书授权失败')
      } finally {
        loading.value = false
      }
    }
    
    // 返回工具页面
    const goBack = () => {
      router.push('/tools-component')
    }
    
    // 重新授权
    const retry = () => {
      // 重新跳转到飞书授权页面
      window.location.href = generateAuthUrl()
    }
    
    // 生成飞书授权URL
    const generateAuthUrl = () => {
      const clientId = 'cli_a67fa7101f0c500c'
      const redirectUri = encodeURIComponent('https://admin.58option.cn/callback')
      const scope = encodeURIComponent('contact:contact.base:readonly')
      const state = 'state123'
      return `https://open.feishu.cn/open-apis/authen/v1/authorize?app_id=${clientId}&redirect_uri=${redirectUri}&scope=${scope}&state=${state}`
    }
    
    onMounted(() => {
      handleCallback()
    })
    
    return {
      loading,
      success,
      successMessage,
      errorMessage,
      goBack,
      retry
    }
  }
}
</script>

<style scoped>
.callback-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

.loading-spinner {
  text-align: center;
  color: white;
}

.loading-spinner .el-icon {
  font-size: 48px;
  margin-bottom: 16px;
}

.loading-spinner p {
  font-size: 18px;
  margin: 0;
}

.result-message {
  background: white;
  padding: 40px;
  border-radius: 12px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
  text-align: center;
  max-width: 500px;
  width: 90%;
}

.success-message .el-icon,
.error-message .el-icon {
  font-size: 64px;
  margin-bottom: 20px;
}

.success-message h3,
.error-message h3 {
  color: #303133;
  margin-bottom: 16px;
  font-size: 24px;
}

.success-message p,
.error-message p {
  color: #606266;
  margin-bottom: 24px;
  line-height: 1.6;
}

.el-button {
  margin: 0 8px;
}
</style>